<template>
    <fieldset :disabled="!matchItemExtension">

        <div class="mb-3">
            <div class="custom-control custom-checkbox">
                <input :value="!!params.override['enabled']"
                       :checked="!!params.override['enabled']"
                       @change="$emit('update', {path: ['override', 'enabled'], value: !params.override['enabled']})"
                       class="custom-control-input"
                       type="checkbox"
                       id="override-enabled">
                <label class="custom-control-label pt-1" for="override-enabled">
                    Override line data
                </label>
            </div>
            <fieldset :disabled="!params.override['enabled']" class="ml-4">
                <div class="custom-control custom-checkbox">
                    <input :value="!!params.override['confirm']"
                           :checked="!!params.override['confirm']"
                           @change="$emit('update', {path: ['override', 'confirm'], value: !params.override['confirm']})"
                           class="custom-control-input"
                           type="checkbox"
                           id="override-confirm">
                    <label class="custom-control-label pt-1" for="override-confirm">
                        With confirmation
                        <span
                            v-tooltip="'Additionally, ask for confirmation of updating the form data.</br>In some cases, you may need to opt out of updating your data.'">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input :value="!!params.override['force']"
                           :checked="!!params.override['force']"
                           @change="$emit('update', {path: ['override', 'force'], value: !params.override['force']})"
                           class="custom-control-input"
                           type="checkbox"
                           id="override-force">
                    <label class="custom-control-label pt-1" for="override-force">
                        Force replace
                        <span
                            v-tooltip="'Even if there are selected values in the form, they will be overwritten with the data of the selected contact.'">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                </div>
            </fieldset>
        </div>
    </fieldset>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'LineItemSelectExtensionParamsEditor',
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'matchItemExtension'
        ])
    }
}
</script>
